import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Carrier, KPIDashboardService } from '~lmo/kpidashboard/kpidashboard.service';
import { trackById } from '~utilities/trackById';

@Component({
  selector: 'sa-carrier-selector',
  styleUrls: ['./carrier-selector.component.scss'],
  templateUrl: './carrier-selector.component.html',
})
export class CarrierSelectorComponent implements OnInit {
  public carriers: Carrier[] = [];
  public selectedCarrierId: number | null = null;

  constructor(private kpiDashboardService: KPIDashboardService, private activatedRoute: ActivatedRoute) {}

  public readonly trackById = trackById;

  public ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.selectedCarrierId = params['region_id'] ? +params['region_id'] : null;
    });

    this.kpiDashboardService.getCarriers$().subscribe((data) => {
      this.carriers = this.prependAllCarriers(data);
      const localCarrierID = this.kpiDashboardService.getLocalStorage('average_turn_rate_carrier') ?? 0;
      if (localCarrierID !== 0) {
        this.selectedCarrierId = localCarrierID;
      } else {
        this.selectedCarrierId = this.carriers[0].id;
      }
      this.setCarrierID(this.selectedCarrierId);
      if (this.selectedCarrierId && !this.carriers.some((region) => region.id === this.selectedCarrierId)) {
        this.selectedCarrierId = null;
      }
    });

    this.kpiDashboardService.regionID$.subscribe((regionID) => {
      if (regionID) {
        this.fetchCarriersByRegionID(regionID);
      } else {
        this.fetchCarriers();
      }
    });
  }

  private fetchCarriersByRegionID(regionID: number) {
    this.kpiDashboardService.getCarriersByRegionID$(regionID).subscribe((data) => {
      this.carriers = this.prependAllCarriers(data);
      const localCarrierID = this.kpiDashboardService.getLocalStorage('average_turn_rate_carrier') ?? 0;
      this.setCarrierID(localCarrierID);
      if (this.selectedCarrierId && !this.carriers.some((region) => region.id === this.selectedCarrierId)) {
        this.selectedCarrierId = 0;
      }
    });
  }

  private fetchCarriers() {
    this.kpiDashboardService.getCarriers$().subscribe((data) => {
      this.carriers = this.prependAllCarriers(data);
      const localCarrierID = this.kpiDashboardService.getLocalStorage('average_turn_rate_carrier') ?? 0;
      this.setCarrierID(localCarrierID);
      if (this.selectedCarrierId && !this.carriers.some((region) => region.id === this.selectedCarrierId)) {
        this.selectedCarrierId = null;
      }
    });
  }

  public setCarrierID(carrierID: number): void {
    this.kpiDashboardService.setCarrierID(carrierID);
    this.kpiDashboardService.setLocalStorage('average_turn_rate_carrier', carrierID);
  }

  private prependAllCarriers(data: Carrier[]): Carrier[] {
    data = [
      ...data,
      {
        id: 0,
        name: 'All Carriers',
      },
    ];
    return this.sortCarriersById(data);
  }

  private sortCarriersById(carriers: Carrier[]): Carrier[] {
    return [...carriers].sort((a, b) => a.id - b.id);
  }
}
